import { cn } from "@/lib/utils";

export function ArrowIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3.5 w-2 text-ruby-red", className)}
      fill="none"
      viewBox="0 0 8 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1l6 6-6 6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function StarIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3.5 w-[15px] text-maize", className)}
      viewBox="0 0 15 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.646 5.058l-4.858-.441L7.858.23a.393.393 0 00-.716 0l-1.93 4.387-4.858.44a.38.38 0 00-.221.666l3.666 3.152-1.073 4.66c-.075.325.285.581.578.41L7.5 11.507l4.195 2.438c.294.171.654-.085.58-.41L11.2 8.874l3.666-3.152a.38.38 0 00-.22-.665z"
        fill="currentColor"
      />
    </svg>
  );
}
